  <template>
  <div class="page-not-found">
    <div class="page-not-found__wrapper">
      <div class="page-not-found__caption">
        <div class="page-not-found__title">¡Vaya!</div>
        <div class="page-not-found__notice">No podemos encontrar la página que estás buscando.</div>
        <div class="page-not-found__code">Código de error 404</div>
        <a class="page-not-found__link" href="/">Llévame a la página de inicio</a>        
      </div>
      <div class="page-not-found__graphic">
        <img src="/assets/nhood-404.png" alt="404">
      </div>
    </div>
  </div>
</template>

<script>
import ButtonPrimary from "../../../components/global/ButtonPrimary"


export default {
  name: 'PageNotFound',
  data: () => ({
  }),
  components: {
    ButtonPrimary
  },
  created () {
  },
  mounted () {
  },
  methods: {
    goBack () {
      window.history.go(-2)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../../scss/global/includes";

.page-not-found {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
}

.page-not-found__wrapper {
  width: 800px;
  max-width: 100%;
  padding: 0 16px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: grid;
  grid-template-columns: 57% calc(43% - 48px);
  gap: 48px;
}

.page-not-found__caption {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

.page-not-found__graphic {
  width: 100%;
}

.page-not-found__title {
  color: #51ACAE;
  width: 100%;
  font-size: 120px;
  font-family: "Comfortaa", sans-serif;
  font-weight: 700;
  line-height: 1;
}

@media screen and (max-width: 768px) { /* Adjust 768px as per your mobile screen size */
    .page-not-found__title {
        font-size: 60px;
    }
}

.page-not-found__notice {
  font-size: 32px;
  font-family: "Comfortaa", sans-serif;
  font-weight: 700;
  color: #000000;
}

@media screen and (max-width: 768px) { /* Adjust 768px as per your mobile screen size */
    .page-not-found__notice {
        font-size: 18px;
    }
}


.page-not-found__code {
  font-size: 18px;
  font-family: "Comfortaa", sans-serif;
  font-weight: 700;
  color: #000000;
}

@media screen and (max-width: 768px) { /* Adjust 768px as per your mobile screen size */
    .page-not-found__code {
        font-size: 14px;
    }
}

.page-not-found__link {
  font-size: 18px;
  font-family: "Comfortaa", sans-serif;
  font-weight: 700;
  color: #51ACAE;
  text-decoration: underline;
}

@media screen and (max-width: 768px) { /* Adjust 768px as per your mobile screen size */
    .page-not-found__link {
        font-size: 14px;
    }
}
</style>
